import PageTitle from '../components/CommonComps/Titles/PageTitle';
import ShowAllRetainAgreements from '../components/RetainAgreementsComps/ShowAllRetainAgreements';

const RetainAgreements = () => {
  // rendering retain agreements page component here
  return (
    <>
      <PageTitle title='Retain Agreements' />

      <ShowAllRetainAgreements />
    </>
  );
};

export default RetainAgreements;
